import Vue from 'vue';
import axios from 'axios'
/**
 * @module Store/files
 * @description Module for file handling
 */
const environment = `${process.env.VUE_APP_ENV}`.replace('.','_') // nake in taskmanager2
const link = `${process.env.VUE_APP_LOCATION}`
/**
 * @constant State of files store
 * @type {object}
 * @description This constant holds the state of files store
 * */
const state = {
    userTasks: [],
    tasks: {},
};

/**
 * @constant Getters
 * @type {object}
 * @description This constant represents the getters for the files store
 * */
const getters = {
    getUserTasks: state => state.userTasks,
    getTasks: state => state.tasks,
};

/**
 * @constant Mutations
 * @type {object}
 * @description This constant represents the mutations for the files store
 * */
const mutations = {
    setUserTasks: (state, payload) => state.userTasks = payload,
    removeUserTasks: (state, payload) => state.userTasks = [],
    setTasks: (state, payload) => state.tasks = payload,
    removeTasks: (state, payload) => tasks.userTasks = {},
};

/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    async getUserTasksAsync ({getters, commit} ) {
        try {
            let q = `${link}/taskmanager2/${environment}/user/tasks/${getters.getUserId}`;
            const { data} = await axios.get(q, {headers: {
                Authorization: 'Basic ' + window.localStorage.getItem('tokenCPH')
            }});
            commit('setUserTasks', data)
            return data;
        } catch (error) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `get user tasks`
            });
        }
    },
    async getTasksAsync ({getters, commit} ) {
        try {
            let q = `${link}/taskmanager2/${environment}/`;
            const { data} = await axios.get(q, {headers: {
                Authorization: 'Basic ' + window.localStorage.getItem('tokenCPH')
            }});
            commit('setTasks', data)
            return data;
            
        } catch (error) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `get tasks`
            });
        }
    },
    async createTaskAsync ({getters, commit, dispatch}, { cubes = [], contexts = [], userID = '', toSend} ) {
        try {
            let q = `${link}/taskmanager2/${environment}/`;
            const { data} = await axios.post(q, {
                cubes,
                contexts,
                userID,
                toSend
            }, {headers: {
                Authorization: 'Basic ' + window.localStorage.getItem('tokenCPH')
            }});
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `add update task`
            });
            dispatch('runTaskAsync', data.id)

            try {
                await Vue.axios.post('/collecter/classes/updatelogs', { toSend,cubes, contexts, task: data.id, userid: getters.getUserId, data: { type: "update-shop"} } ,{headers: {'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'}});
            } catch (error) {
                console.error("Update logs error", error);
            }

            return data;
        } catch (error) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `add update task`
            });
        }
    },
    async runTaskAsync ({getters, commit}, id ) {
        try {
            let q = `${link}/taskmanager2/${environment}/${id}/run`;
            const { data} = await axios.post(q,{}, {headers: {
                Authorization: 'Basic ' + window.localStorage.getItem('tokenCPH')
            }});
            //commit('setTasks', data)
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `run task ${id}`
            });
            try {
                await Vue.axios.post('/collecter/classes/updatelogs', { task: id, userid: getters.getUserId, data: { type: "update-shop-run"} } ,{headers: {'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'}});
            } catch (error) {
                console.error("Run task logs error", error);
            }

            return data;
        } catch (error) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `run task ${id}`
            });
        }
    },
    async unpauseTaskAsync ({getters, commit}, id ) {
        try {
            let q = `${link}/taskmanager2/${environment}/${id}/unpause`;
            const { data} = await axios.post(q, {}, {headers: {
                Authorization: 'Basic ' + window.localStorage.getItem('tokenCPH')
            }});
            //commit('setTasks', data)
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `unpause task ${id}`
            });
            try {
                await Vue.axios.post('/collecter/classes/updatelogs', { task: id, userid: getters.getUserId, data: { type: "update-shop-unpause"} } ,{headers: {'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'}});
            } catch (error) {
                console.error("Update logs error", error);
            }

            return data;
            
        } catch (error) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `unpause task ${id}`
            });
        }
    },
    async pauseTaskAsync ({getters, commit}, id ) {
        try {
            let q = `${link}/taskmanager2/${environment}/${id}/pause`;
            const { data} = await axios.post(q, {},{headers: {
                Authorization: 'Basic ' + window.localStorage.getItem('tokenCPH')
            }});
            //commit('setTasks', data)
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `pause task ${id}`
            });
            try {
                await Vue.axios.post('/collecter/classes/updatelogs', { task: id, userid: getters.getUserId, data: { type: "update-shop-pause"} } ,{headers: {'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'}});
            } catch (error) {
                console.error("Update logs error", error);
            }

            return data;
        } catch (error) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `pause task ${id}`
            });
        }
    },
    async removeTaskAsync ({getters, commit}, id ) {
        try {
            let q = `${link}/taskmanager2/${environment}/${id}`;
            const { data} = await axios.delete(q, {headers: {
                Authorization: 'Basic ' + window.localStorage.getItem('tokenCPH')
            }});
            //commit('setTasks', data)
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `remove task ${id}`
            });
            try {
                await Vue.axios.post('/collecter/classes/updatelogs', { task: id, userid: getters.getUserId, data: { type: "update-shop-remove-task"} } ,{headers: {'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'}});
            } catch (error) {
                console.error("Update logs error", error);
            }

            return data;
        } catch (error) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `remove task ${id}`
            });
        }
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
